// extracted by mini-css-extract-plugin
module.exports = {"contentWrap":"contentWrap--3g_ux"};